import React from 'react'
import './Experince.css'

const Experince = () => {
  return (
    <div className='Experince'>
      <h2 className='Experince__header'>Work experince</h2>   
      <div className='Experince__line'></div> 
      <h3 className='Experince__years'>2010 - 2021</h3>
      <p className='Experince__info'>Worked as an engineer for non-destructive testing of metal and welding in JSC "Belenergoremnaladka".</p>
    </div>
  )
}

export default Experince